(function(){
  if(!window.UP_SNIPPETS || !Array.isArray(UP_SNIPPETS)) return;

  // Modal registry for global close coordination
  var allModals = [];

  // Global close event - closes all popups except the specified one
  function closeAllPopups(exceptModal) {
    document.dispatchEvent(new CustomEvent('anchor-close-popups', { detail: { except: exceptModal } }));
  }

  document.addEventListener('anchor-close-popups', function(e) {
    var except = e.detail && e.detail.except;
    allModals.forEach(function(m) {
      // Fly-ins are non-exclusive: they have no backdrop and are designed to
      // coexist with other popups, so they are never auto-closed just because
      // another popup opened. Only close exclusive popups (modal/theater/
      // drawer/fullscreen).
      if (m !== except && !m.hidden && m._exclusive !== false) {
        closeModal(m);
      }
    });
  });

  // ── Page scroll lock ────────────────────────────────────────────────────
  // Refcounted, because fly-ins coexist with an exclusive popup: a fly-in
  // closing must never release a lock the modal behind it still holds. The
  // class goes on <html>; frontend.css locks html and body together.
  var scrollLocks = 0;

  function lockScroll(modal){
    if(modal._scrollLocked) return;
    modal._scrollLocked = true;
    if(scrollLocks++ > 0) return;
    var doc = document.documentElement;
    // Reserve the width the scrollbar occupied, so the page underneath doesn't
    // jump sideways the moment the popup opens.
    var gap = (window.innerWidth || doc.clientWidth) - doc.clientWidth;
    if(gap > 0){ doc.style.setProperty('--up-scrollbar-gap', gap + 'px'); }
    doc.classList.add('up-scroll-lock');
  }

  function unlockScroll(modal){
    if(!modal._scrollLocked) return;
    modal._scrollLocked = false;
    if(--scrollLocks > 0) return;
    scrollLocks = 0;
    var doc = document.documentElement;
    doc.classList.remove('up-scroll-lock');
    doc.style.removeProperty('--up-scrollbar-gap');
  }

  // Storage helpers
  function markShown(id, mode, minutes){
    try{
      if(mode === 'session'){
        sessionStorage.setItem('up_shown_'+id, String(Date.now()));
      } else {
        var key = 'up_cool_'+id;
        var until = Date.now() + (Math.max(1, minutes|0) * 60 * 1000);
        localStorage.setItem(key, String(until));
      }
    } catch(e){}
  }
  function shouldShow(id, mode, minutes){
    try{
      if(mode === 'session'){
        return !sessionStorage.getItem('up_shown_'+id);
      } else {
        var key = 'up_cool_'+id;
        var until = parseInt(localStorage.getItem(key) || '0', 10);
        return !(until && Date.now() < until);
      }
    } catch(e){
      // if storage is blocked, show anyway
      return true;
    }
  }

  function buildModalShell(isVideo, popupStyle){
    popupStyle = popupStyle || 'modal';
    var modal = document.createElement('div');
    modal.className = 'up-modal up-style-' + popupStyle;
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.hidden = true;

    var backdrop = document.createElement('div');
    backdrop.className = 'up-modal__backdrop';
    backdrop.setAttribute('data-close','');
    modal.appendChild(backdrop);

    if(isVideo){
      // Video dialog with space for content under the player
      var dialog = document.createElement('div');
      dialog.className = 'up-modal__dialog';

      var close = document.createElement('button');
      close.className = 'up-modal__close';
      close.type = 'button';
      close.setAttribute('aria-label','Close popup');
      close.setAttribute('data-close','');
      close.setAttribute('data-close-btn','');
      close.textContent = '×';

      var frame = document.createElement('div');
      frame.className = 'up-modal__frame';
      frame.setAttribute('data-frame','');

      var after = document.createElement('div');
      after.className = 'up-video-after';
      after.setAttribute('data-after','');

      dialog.appendChild(close);
      dialog.appendChild(frame);
      dialog.appendChild(after);
      modal.appendChild(dialog);
    } else {
      // Pure HTML content dialog
      var wrap = document.createElement('div');
      wrap.className = 'up-content-wrap';

      var close2 = document.createElement('button');
      close2.className = 'up-modal__close';
      close2.type = 'button';
      close2.setAttribute('aria-label','Close popup');
      close2.setAttribute('data-close','');
      close2.setAttribute('data-close-btn','');
      close2.textContent = '×';

      var inner = document.createElement('div');
      inner.className = 'up-content__inner';
      inner.setAttribute('data-content','');

      wrap.appendChild(close2);
      wrap.appendChild(inner);
      modal.appendChild(wrap);
    }

    document.body.appendChild(modal);
    allModals.push(modal);
    return modal;
  }

  function normalizePopupStyle(style){
    style = String(style || '').toLowerCase().trim();
    if(!style) return 'modal';
    if(style === 'flyin' || style === 'fly-in' || style === 'flyin-center' || style === 'flyin-bottom-center'){
      return 'flyin-bottom';
    }
    if(style === 'flyin-left'){
      return 'flyin-bottom-left';
    }
    if(style === 'flyin-right'){
      return 'flyin-bottom-right';
    }
    return style;
  }

  function buildYouTubeSrc(id, opts){
    opts = opts || {};
    var p = new URLSearchParams({
      autoplay: opts.autoplay ? '1' : '0',
      playsinline: '1',
      rel: '0',
      modestbranding: '1',
      enablejsapi: '1'
    });
    // Mute when asked. Needed for autoplay (browsers block unmuted autoplay) and
    // for a muted preload so a later programmatic play() is allowed without a gesture.
    if(opts.muted){
      p.set('mute', '1');
    }
    // youtube-nocookie.com defers YouTube's tracking cookies (YSC, VISITOR_INFO1_LIVE,
    // __Secure-YNID, __Secure-ROLLOUT_TOKEN) so a page with a popup player doesn't fail
    // the third-party-cookies audit or populate inspector issues on load.
    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?' + p.toString();
  }
  function buildVimeoSrc(id, opts){
    opts = opts || {};
    var p = new URLSearchParams({
      autoplay: opts.autoplay ? '1' : '0',
      byline: '0',
      title: '0',
      portrait: '0',
      dnt: '1'
    });
    if(opts.muted){
      p.set('muted', '1');
    }
    return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?' + p.toString();
  }

  /**
   * Activate <script> tags inside a container after innerHTML insertion.
   * innerHTML does not execute scripts, so we replace each <script> with
   * a fresh element the browser will load/run.
   */
  function activateScripts(container){
    var scripts = container.querySelectorAll('script');
    for(var i = 0; i < scripts.length; i++){
      var old = scripts[i];
      var s   = document.createElement('script');
      // Copy all attributes (src, async, type, etc.)
      for(var j = 0; j < old.attributes.length; j++){
        s.setAttribute(old.attributes[j].name, old.attributes[j].value);
      }
      // Copy inline content
      if(old.textContent) s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    }
  }

  function videoIframe(src){
    return '<iframe src="'+src+'" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>';
  }

  /**
   * Start playback on an already-preloaded iframe via the provider postMessage
   * API — no reload, so the warm player plays instantly. If the player isn't
   * ready yet (user clicked within the first moment), the command is a no-op
   * and the visitor simply presses play on the visible poster.
   */
  function playPreloaded(modal, provider, muted){
    var iframe = modal.querySelector('[data-frame] iframe');
    if(!iframe || !iframe.contentWindow) return;
    try{
      if(provider === 'youtube'){
        if(muted){ iframe.contentWindow.postMessage(JSON.stringify({event:'command',func:'mute',args:[]}), '*'); }
        iframe.contentWindow.postMessage(JSON.stringify({event:'command',func:'playVideo',args:[]}), '*');
      } else {
        if(muted){ iframe.contentWindow.postMessage(JSON.stringify({method:'setVolume',value:0}), '*'); }
        iframe.contentWindow.postMessage(JSON.stringify({method:'play'}), '*');
      }
    }catch(e){}
  }

  // ── Video end behaviour ("When the video ends" setting) ─────────────────
  // Uses the providers' own postMessage APIs (no SDK): Vimeo sends timeupdate /
  // ended once subscribed; YouTube streams infoDelivery after a "listening"
  // handshake. We act END_LEAD seconds before the end so the player's end
  // screen (Vimeo's grey replay panel, YouTube's suggestions) never shows.
  var END_LEAD = 0.6;      // seconds before the end to act
  var END_FADE_MS = 600;   // fade duration for video_end = 'close'
  var endModals = [];      // modals whose video_end is hold/close

  function endIframe(modal){ return modal.querySelector('[data-frame] iframe'); }

  function endCommand(modal, cmd, arg){
    var iframe = endIframe(modal);
    if(!iframe || !iframe.contentWindow) return;
    var msg;
    if(modal._endProvider === 'youtube'){
      var yt = { pause: 'pauseVideo', seek: 'seekTo' };
      msg = { event: 'command', func: yt[cmd], args: cmd === 'seek' ? [arg, true] : [] };
    } else {
      var vm = { pause: 'pause', seek: 'setCurrentTime' };
      msg = cmd === 'seek' ? { method: vm[cmd], value: arg } : { method: vm[cmd] };
    }
    try{ iframe.contentWindow.postMessage(JSON.stringify(msg), '*'); }catch(e){}
  }

  function endSubscribe(modal){
    var iframe = endIframe(modal);
    if(!iframe || !iframe.contentWindow) return;
    try{
      if(modal._endProvider === 'youtube'){
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 'up-' + modal._endId, channel: 'widget' }), '*');
      } else {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'timeupdate' }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'ended' }), '*');
      }
    }catch(e){}
  }

  function fadeOutAndClose(modal){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){ closeModal(modal); return; }
    modal.classList.add('up-modal--ending');
    modal.style.setProperty('--up-end-fade', END_FADE_MS + 'ms');
    setTimeout(function(){
      closeModal(modal);
      modal.classList.remove('up-modal--ending');
    }, END_FADE_MS);
  }

  // Called with the playhead position; `ended` is true when the player
  // reported the end itself (we missed the lead window, e.g. a seek to the end).
  function endTick(modal, seconds, duration, ended){
    if(modal.hidden || !(duration > 0)) return;
    // Closing fades over the tail, so it can start early; holding should cut as
    // late as the ~250ms timeupdate cadence safely allows.
    var lead = modal._videoEnd === 'close' ? END_LEAD : 0.3;
    if(!ended && duration - seconds > lead){
      // Rewound / replayed: re-arm.
      if(duration - seconds > lead + 1) modal._endHandled = false;
      return;
    }
    if(modal._endHandled) return;
    modal._endHandled = true;
    if(modal._videoEnd === 'close'){
      fadeOutAndClose(modal);
    } else {
      if(ended) endCommand(modal, 'seek', Math.max(0, duration - 0.1));
      endCommand(modal, 'pause');
    }
  }

  function endModalFor(source){
    for(var i = 0; i < endModals.length; i++){
      var f = endIframe(endModals[i]);
      if(f && f.contentWindow === source) return endModals[i];
    }
    return null;
  }

  window.addEventListener('message', function(e){
    if(!endModals.length) return;
    if(!/^https:\/\/(player\.vimeo\.com|www\.youtube(-nocookie)?\.com)$/.test(e.origin)) return;
    var modal = endModalFor(e.source);
    if(!modal) return;
    var d = e.data;
    if(typeof d === 'string'){ try{ d = JSON.parse(d); }catch(err){ return; } }
    if(!d || typeof d !== 'object') return;
    if(modal._endProvider === 'youtube'){
      if(d.event !== 'infoDelivery' || !d.info) return;
      if(typeof d.info.duration === 'number') modal._endDuration = d.info.duration;
      if(d.info.playerState === 0){ endTick(modal, modal._endDuration || 0, modal._endDuration || 0, true); return; }
      if(typeof d.info.currentTime === 'number') endTick(modal, d.info.currentTime, modal._endDuration || 0, false);
    } else {
      if(d.event === 'ready'){ endSubscribe(modal); return; }
      if(d.event === 'timeupdate' && d.data){
        modal._endDuration = d.data.duration;
        endTick(modal, d.data.seconds, d.data.duration, false);
      } else if(d.event === 'ended'){
        var dur = (d.data && d.data.duration) || modal._endDuration || 0;
        endTick(modal, dur, dur, true);
      }
    }
  });

  // iframe load doesn't bubble, but it does reach a capturing listener. Covers
  // every (re)build of the player: open, and the src reset on close.
  document.addEventListener('load', function(e){
    var t = e.target;
    if(!t || t.tagName !== 'IFRAME') return;
    for(var i = 0; i < endModals.length; i++){
      if(endIframe(endModals[i]) === t){
        endModals[i]._endHandled = false;
        endSubscribe(endModals[i]);
        return;
      }
    }
  }, true);

  function registerVideoEnd(modal, sn, provider){
    var mode = sn.video_end;
    if(mode !== 'hold' && mode !== 'close') return;
    if(provider !== 'youtube' && provider !== 'vimeo') return;
    modal._videoEnd = mode;
    modal._endProvider = provider;
    modal._endId = sn.id;
    endModals.push(modal);
  }

  function isFullscreen(modal){
    return modal.classList.contains('up-style-fullscreen');
  }

  function nowTs(){ return (window.performance && performance.now) ? performance.now() : Date.now(); }

  function escapeCssIdentifier(value){
    value = String(value || '').trim();
    if(window.CSS && typeof window.CSS.escape === 'function'){
      return window.CSS.escape(value);
    }
    return value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function classTriggerSelector(value){
    return String(value || '').trim().split(/\s+/).map(function(part){
      return part.replace(/^[.#]+/, '');
    }).filter(Boolean).map(function(part){
      return '.' + escapeCssIdentifier(part);
    }).join('');
  }

  function idTriggerSelector(value){
    value = String(value || '').trim().replace(/^#/, '');
    return value ? '#' + escapeCssIdentifier(value) : '';
  }

  function closestTrigger(el, selector){
    if(!selector || !el.closest) return null;
    try{
      return el.closest(selector);
    }catch(e){
      return null;
    }
  }

  function queryFirst(selector){
    if(!selector) return null;
    try{
      return document.querySelector(selector);
    }catch(e){
      return null;
    }
  }

  function runAfterFirstScroll(callback){
    var done = false;
    var onFirstScroll = function(){
      if(done) return;
      done = true;
      window.removeEventListener('scroll', onFirstScroll);
      callback();
    };
    window.addEventListener('scroll', onFirstScroll, { passive: true });
  }

  // Reveal a standard (non-fullscreen) modal: just unhide and focus the close.
  function revealModal(modal){
    modal._openedAt = nowTs();
    modal._closing = false;
    if(modal._closeTimer){ clearTimeout(modal._closeTimer); modal._closeTimer = null; }
    modal.hidden = false;
    if(modal._lockScroll){ lockScroll(modal); }
    var closeBtn = modal.querySelector('.up-modal__close');
    if(closeBtn){ closeBtn.focus(); }
  }

  // ── Fullscreen takeover (self-anchoring; driven by an inline shortcode card) ──
  // The transform that makes the full-viewport dialog visually occupy the
  // anchor's CURRENT on-screen rect (origin 0,0) — the collapsed start/end state.
  function collapsedTransform(anchor){
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = anchor ? anchor.getBoundingClientRect() : { left: 0, top: 0, width: vw, height: vh };
    var sx = Math.max(0.02, r.width / vw);
    var sy = Math.max(0.02, r.height / vh);
    return 'translate(' + r.left + 'px,' + r.top + 'px) scale(' + sx + ',' + sy + ')';
  }

  // Expand: grow the overlay from the anchor's rect to the full viewport (FLIP)
  // while the backdrop fades in, and play the (preloaded) video muted.
  function expandTakeover(modal, provider, id, anchor){
    if(modal._expanded || !anchor) return;
    modal._expanded = true;
    modal._anchor = anchor;
    modal._openedAt = nowTs();
    modal._closing = false;
    if(modal._closeTimer){ clearTimeout(modal._closeTimer); modal._closeTimer = null; }

    closeAllPopups(modal); // replace any other open popup

    // Scroll-driven open has no user gesture, so playback must be muted.
    var frameWrap = modal.querySelector('[data-frame]');
    if(modal._preloaded){
      playPreloaded(modal, provider, true);
    } else if(frameWrap){
      var src = provider === 'youtube'
        ? buildYouTubeSrc(id, { autoplay: true, muted: true })
        : buildVimeoSrc(id, { autoplay: true, muted: true });
      frameWrap.innerHTML = videoIframe(src);
    }

    var dialog = modal.querySelector('.up-modal__dialog');
    var backdrop = modal.querySelector('.up-modal__backdrop');

    modal.hidden = false;
    if(dialog){
      dialog.style.transition = 'none';
      dialog.style.transformOrigin = '0 0';
      dialog.style.transform = collapsedTransform(anchor);
    }
    if(backdrop){ backdrop.style.transition = 'none'; backdrop.style.opacity = '0'; }
    if(dialog){ void dialog.offsetWidth; } // commit the collapsed start state
    requestAnimationFrame(function(){
      if(dialog){
        dialog.style.transition = 'transform 0.45s cubic-bezier(0.22,0.61,0.36,1)';
        dialog.style.transform = 'translate(0px,0px) scale(1,1)';
      }
      if(backdrop){ backdrop.style.transition = 'opacity 0.45s ease'; backdrop.style.opacity = '1'; }
    });
  }

  // Collapse: shrink back to the anchor's current rect, then hide, stop
  // playback, and re-arm the preload so the next expand is instant again.
  function collapseTakeover(modal){
    if(!modal._expanded || modal._closing) return;
    modal._closing = true;
    modal._expanded = false;

    var dialog = modal.querySelector('.up-modal__dialog');
    var backdrop = modal.querySelector('.up-modal__backdrop');

    if(dialog){
      dialog.style.transition = 'transform 0.4s ease';
      dialog.style.transform = collapsedTransform(modal._anchor);
    }
    if(backdrop){ backdrop.style.transition = 'opacity 0.4s ease'; backdrop.style.opacity = '0'; }

    modal._closeTimer = setTimeout(function(){
      modal.hidden = true;
      var f = modal.querySelector('[data-frame]');
      if(f){
        if(modal._preloaded && modal._preloadSrc){
          var iframe = f.querySelector('iframe');
          if(iframe){ iframe.src = modal._preloadSrc; }
          else { f.innerHTML = videoIframe(modal._preloadSrc); }
        } else {
          f.innerHTML = '';
        }
      }
      if(dialog){ dialog.style.transition = 'none'; dialog.style.transform = ''; }
      if(backdrop){ backdrop.style.transition = 'none'; backdrop.style.opacity = ''; }
      modal._closing = false;
      modal._closeTimer = null;
    }, 420);
  }

  function openVideo(modal, provider, id, autoplay, extra){
    var frameWrap = modal.querySelector('[data-frame]');
    if(!frameWrap) return;

    var opts = { autoplay: !!autoplay, muted: !!(extra && extra.muted) };
    if(modal._preloaded){
      // Reuse the player that's already warmed up in the background.
      if(autoplay){ playPreloaded(modal, provider, opts.muted); }
    } else {
      var src = provider === 'youtube' ? buildYouTubeSrc(id, opts) : buildVimeoSrc(id, opts);
      frameWrap.innerHTML = videoIframe(src);
    }

    // Optional content under the video
    var after = modal.querySelector('[data-after]');
    if(after){
      var css = extra && extra.css ? '<style>'+extra.css+'</style>' : '';
      var html = extra && extra.html ? extra.html : '';
      after.innerHTML = css + html;
      activateScripts(after);
      try{ new Function(extra && extra.js ? extra.js : '')(); }catch(e){}
    }

    revealModal(modal);
  }

  function openContent(modal, html, css, js){
    var content = modal.querySelector('[data-content]');
    if(!content) return;
    var style = '<style>'+ (css || '') +'</style>';
    content.innerHTML = style + (html || '');
    activateScripts(content);
    try{ new Function(js || '')(); }catch(e){}
    revealModal(modal);
  }

  function closeModal(modal){
    if(modal.hidden) return;
    // Before the early returns below, so a lock can never outlive its popup.
    unlockScroll(modal);
    // Fullscreen takeover animates back to its anchor instead of just hiding.
    if(isFullscreen(modal)){
      collapseTakeover(modal);
      return;
    }
    if(modal._closing) return;

    // Stop playback / clear under-content, re-arming the preload if present.
    var f = modal.querySelector('[data-frame]');
    if(f){
      if(modal._preloaded && modal._preloadSrc){
        // Reset to the no-autoplay URL: stops playback AND re-arms the preload
        // so reopening is instant again, without re-fetching on every open.
        var iframe = f.querySelector('iframe');
        if(iframe){ iframe.src = modal._preloadSrc; }
        else { f.innerHTML = videoIframe(modal._preloadSrc); }
      } else {
        f.innerHTML = '';
      }
    }
    var a = modal.querySelector('[data-after]');
    if(a) a.innerHTML = '';
    modal.hidden = true;
  }

  function wireClose(modal){
    modal.addEventListener('click', function(e){
      var t = e.target;
      if(t && t.hasAttribute('data-close')){
        closeModal(modal);
      }
    });
    document.addEventListener('click', function(e){
      if(modal.hidden) return;
      var now = (typeof e.timeStamp === 'number' && e.timeStamp > 0)
        ? e.timeStamp
        : ((window.performance && performance.now) ? performance.now() : Date.now());
      if(modal._openedAt && (now - modal._openedAt) < 50) return;

      var shell = modal.querySelector('.up-modal__dialog, .up-content-wrap');
      if(!shell) return;
      if(shell.contains(e.target)) return;
      closeModal(modal);
    }, true);
    window.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && !modal.hidden) closeModal(modal);
    });
  }

  function resolveProvider(sn){
    var provider = sn.provider || sn.mode;
    if(provider === 'video'){ provider = sn.provider || 'youtube'; } // unified video mode fallback
    return provider;
  }

  function attach(sn){
    // Class-triggered popups whose trigger element isn't on this page have
    // nothing to bind to — skip them so we never build a modal (and, for video,
    // never load a player) for a trigger that can't fire here. Every trigger is
    // server-rendered, so a DOMContentLoaded-time check can't false-negative.
    // Scoped to class only: delay/scroll/id/page_load triggers are untouched.
    if(sn.trigger && sn.trigger.type === 'class'){
      var _trigSel = classTriggerSelector(sn.trigger.value);
      if(!_trigSel || !queryFirst(_trigSel)) return;
    }

    var isVideo = (sn.mode === 'youtube' || sn.mode === 'vimeo' || sn.mode === 'video');
    var popupStyle = normalizePopupStyle(sn.popup_style);

    // Fullscreen takeover is its own self-anchoring mode (driven by the inline
    // shortcode card, not the trigger system) — handled entirely separately.
    if(popupStyle === 'fullscreen'){
      setupFullscreenTakeover(sn, isVideo);
      return;
    }

    var modal = buildModalShell(isVideo, popupStyle);
    // Fly-ins coexist with other popups; every other style takes over the
    // screen and is mutually exclusive. Drives the close-coordination above.
    modal._exclusive = (popupStyle.indexOf('flyin') !== 0);
    // Only styles that cover the screen can freeze the page. A fly-in is a
    // compact card the visitor is meant to keep reading past, and the
    // fullscreen takeover (returned above) is itself scroll-driven, so
    // neither ever locks — whatever the setting says.
    // Absent means on, matching the PHP default, so popups saved before this
    // setting existed still lock.
    modal._lockScroll = (sn.lock_scroll == null || String(sn.lock_scroll) !== '0') && modal._exclusive;
    if (popupStyle === 'modal' && sn.modal_max_width) {
      modal.style.setProperty('--up-modal-max-width', sn.modal_max_width);
    }
    if (popupStyle === 'theater') {
      if (sn.theater_max_width) modal.style.setProperty('--up-theater-max-width', sn.theater_max_width);
      if (sn.theater_max_height) modal.style.setProperty('--up-theater-max-height', sn.theater_max_height);
    }
    if (popupStyle.indexOf('flyin') === 0 && sn.flyin_max_width) {
      modal.style.setProperty('--up-flyin-max-width', sn.flyin_max_width);
    }
    wireClose(modal);

    // Store modal reference on snippet for card click handler
    sn._modal = modal;

    // Resolve provider from snippet (for unified video mode)
    var provider = resolveProvider(sn);
    if(isVideo) registerVideoEnd(modal, sn, provider);

    // Apply close icon color if set
    if(sn.close_color){
      var closeBtn = modal.querySelector('[data-close-btn]');
      if(closeBtn) closeBtn.style.color = sn.close_color;
    }

    // No preloading: the video iframe is built on demand in the open handler
    // (openVideo / expandTakeover). Click-to-load is normal YouTube behavior and
    // the delay is imperceptible, whereas preloading a player per popup on every
    // page is the dominant page-weight and Total-Blocking-Time cost.

    function triggerOpen(){
      // Re-check at fire time, not just at bind time: a page may sit open across a
      // window boundary, and delay_ms timers / scroll observers fire long after attach().
      if(!withinSchedule(sn)) return;

      // Exclusive popups take over the screen, so opening one closes the
      // others. Fly-ins are non-exclusive and leave existing popups alone.
      if (modal._exclusive) closeAllPopups(modal);

      // For "Click on class", treat the popup like an explicit user action and
      // avoid frequency gating that can make clicks appear "broken".
      var bypassFrequency = (trig && trig.type === 'class');
      if(!bypassFrequency && !shouldShow(sn.id, sn.frequency.mode, sn.frequency.cooldownMinutes)) return;
      if(isVideo){
        // Autoplay must be muted unless this is a genuine user click (class/id) —
        // browsers block unmuted autoplay for page_load/scroll-triggered playback.
        var userClick = (trig && (trig.type === 'class' || trig.type === 'id'));
        var muteForAutoplay = !!sn.autoplay && !userClick;
        openVideo(modal, provider, sn.video_id, !!sn.autoplay, { html: sn.html, css: sn.css, js: sn.js, muted: muteForAutoplay });
      } else {
        // Use pre-rendered shortcode content if in shortcode mode, otherwise use HTML
        var content = (sn.mode === 'shortcode' && sn.shortcode_content) ? sn.shortcode_content : sn.html;
        openContent(modal, content, sn.css, sn.js);
      }
      if(!bypassFrequency){
        markShown(sn.id, sn.frequency.mode, sn.frequency.cooldownMinutes);
      }
    }

    // Expose triggerOpen for card click handler
    sn._triggerOpen = triggerOpen;

    var trig = sn.trigger || {type:'page_load', value:'', delay:0};
    if(trig.type === 'page_load'){
      var delay = Math.max(0, parseInt(trig.delay || 0, 10));
      if(delay > 0){
        setTimeout(triggerOpen, delay);
      } else {
        setTimeout(triggerOpen, 0);
      }
    } else if(trig.type === 'class'){
      if(!trig.value) return;
      var selector = classTriggerSelector(trig.value);
      document.addEventListener('click', function(e){
        var el = e.target;
        if(closestTrigger(el, selector)){
          e.preventDefault();
          triggerOpen();
        }
      });
    } else if(trig.type === 'id'){
      if(!trig.value) return;
      var idSel = idTriggerSelector(trig.value);
      document.addEventListener('click', function(e){
        var el = e.target;
        if(closestTrigger(el, idSel)){
          e.preventDefault();
          triggerOpen();
        }
      });
    } else if(trig.type === 'scroll'){
      var fired = false;
      function fireOnce(){
        if(fired) return;
        fired = true;
        triggerOpen();
      }
      var pct = Math.max(0, Math.min(100, parseInt(trig.scrollPercent != null ? trig.scrollPercent : 50, 10)));

      if(trig.scrollMode === 'element'){
        // Fire when a target element reaches the configured visible threshold.
        var target = trig.scrollTarget ? queryFirst(trig.scrollTarget) : null;
        if(!target) return;

        runAfterFirstScroll(function(){
          if('IntersectionObserver' in window){
            // Cap at 0.99: an element taller than the viewport can never report a
            // ratio of exactly 1, so a literal 100% threshold would never fire.
            var thr = Math.min(0.99, Math.max(0, pct/100));
            var io = new IntersectionObserver(function(entries){
              for(var k = 0; k < entries.length; k++){
                if(entries[k].isIntersecting && entries[k].intersectionRatio >= thr){
                  io.disconnect();
                  fireOnce();
                  break;
                }
              }
            }, { threshold: thr });
            io.observe(target);
          } else {
            // No IO support: fire once the target's top scrolls into the viewport.
            var checkEl = function(){
              var r = target.getBoundingClientRect();
              var vh = window.innerHeight || document.documentElement.clientHeight;
              if(r.top < vh && r.bottom > 0){
                window.removeEventListener('scroll', onScrollEl);
                fireOnce();
              }
            };
            var onScrollEl = function(){ requestAnimationFrame(checkEl); };
            window.addEventListener('scroll', onScrollEl, { passive: true });
            checkEl();
          }
        });
      } else {
        // Depth mode: fire after the page has been scrolled pct% of the way down.
        var ticking = false;
        var onScroll = function(){
          if(ticking) return;
          ticking = true;
          requestAnimationFrame(function(){
            ticking = false;
            var doc = document.documentElement;
            var scrollable = doc.scrollHeight - window.innerHeight;
            var y = window.scrollY || window.pageYOffset || 0;
            var scrolledPct = scrollable > 0 ? (y / scrollable) * 100 : 100;
            if(scrolledPct >= pct){
              window.removeEventListener('scroll', onScroll);
              fireOnce();
            }
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }
  }

  // Fullscreen takeover: the inline shortcode card IS the trigger. Render the
  // card where you want it; when it scrolls into view the overlay grows from it
  // and plays, and collapses + stops when it scrolls out. Video-only.
  function setupFullscreenTakeover(sn, isVideo){
    var anchors = document.querySelectorAll('[data-up-popup-id="' + sn.id + '"]');
    if(!anchors.length) return; // shortcode not placed on this page → do nothing

    var provider = resolveProvider(sn);
    if(!isVideo || !sn.video_id || (provider !== 'youtube' && provider !== 'vimeo')) return;

    var modal = buildModalShell(true, 'fullscreen');
    sn._modal = modal;
    wireClose(modal); // × / Esc collapse it
    if(sn.close_color){
      var cb = modal.querySelector('[data-close-btn]');
      if(cb) cb.style.color = sn.close_color;
    }

    // The player is built on expand (expandTakeover), muted so the scroll-driven,
    // gesture-less play is allowed — no eager preload.

    // Clicking the thumbnail expands from that card too (handled in click listener).
    sn._fsExpand = function(anchor){ if(!withinSchedule(sn)) return; expandTakeover(modal, provider, sn.video_id, anchor || anchors[0]); };

    var EXPAND_AT = 0.5; // ≥50% of the card visible → expand; gone → collapse
    if(!('IntersectionObserver' in window)) return; // no IO → click-to-expand only

    Array.prototype.forEach.call(anchors, function(anchor){
      var io = new IntersectionObserver(function(entries){
        for(var k = 0; k < entries.length; k++){
          var en = entries[k];
          if(en.isIntersecting && en.intersectionRatio >= EXPAND_AT){
            if(!modal._expanded && withinSchedule(sn)){ expandTakeover(modal, provider, sn.video_id, anchor); }
          } else if(!en.isIntersecting || en.intersectionRatio <= 0.01){
            // Collapse only when the card that opened it has scrolled away.
            if(modal._expanded && modal._anchor === anchor){ collapseTakeover(modal); }
          }
        }
      }, { threshold: [0, EXPAND_AT] });
      io.observe(anchor);
    });
  }

  // Schedule gate. UP_SNIPPETS is inlined into HTML that may be served from a
  // full-page cache, so the PHP gate alone cannot be trusted at fire time.
  // Bounds are absolute UTC epoch seconds, so the visitor's timezone does not
  // matter — only clock skew, which is immaterial at day-scale windows.
  function withinSchedule(sn){
    var s = (sn && sn.schedule) || {};
    var now = Math.floor(Date.now() / 1000);
    if (s.starts && now <  s.starts) return false;
    if (s.ends   && now >= s.ends)   return false;
    return true;
  }

  // Build a lookup map for snippets by ID. Out-of-window popups are omitted, so
  // a cached shortcode-rendered card finds no snippet and its click does nothing.
  var snippetMap = {};
  UP_SNIPPETS.forEach(function(sn) {
    if (!withinSchedule(sn)) return;
    snippetMap[sn.id] = sn;
  });

  // Video card click handler (for shortcode-rendered cards)
  document.addEventListener('click', function(e) {
    var card = e.target.closest('[data-up-popup-id]');
    if (!card) return;

    var popupId = parseInt(card.getAttribute('data-up-popup-id'), 10);
    var sn = snippetMap[popupId];
    if (!sn) return;

    // Fullscreen takeover expands from the clicked card; others open normally.
    if (sn._fsExpand) {
      e.preventDefault();
      sn._fsExpand(card);
      return;
    }
    if (!sn._triggerOpen) return;
    e.preventDefault();
    sn._triggerOpen();
  });

  // Keyboard support for video cards (Enter/Space)
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    var card = e.target.closest('[data-up-popup-id]');
    if (!card) return;

    e.preventDefault();
    card.click();
  });

  document.addEventListener('DOMContentLoaded', function(){
    UP_SNIPPETS.forEach(function(sn){
      if (!withinSchedule(sn)) return;
      try{ attach(sn); }catch(e){}
    });
  });
})();
